<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="班级">-->
<!--                  <el-input  v-model="queryForm.classId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="过期时间">-->
<!--                  <el-input  v-model="queryForm.expireTime"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="学习进度">-->
<!--                  <el-input  v-model="queryForm.studyProgress"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="学习时长（秒数）">-->
<!--                  <el-input  v-model="queryForm.studyTime"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="最后学习时间">-->
<!--                  <el-input  v-model="queryForm.lastStudyTime"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduClassStudentList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduClassStudent"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduClassStudent(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduClassStudent(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEduClassStudentList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduClassStudentList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="classId"-->
<!--        label="班级"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="expireTime"
        label="过期时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studyProgress"
        label="学习进度"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studyTime"
        label="学习时长（秒数）"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="lastStudyTime"
        label="最后学习时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduClassStudent(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduClassStudent(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduClassStudent(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduClassStudentStates[eduClassStudentState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduClassStudent"
          ref="eduClassStudentForm"
          :rules="rules"
          label-width="126px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="班级"-->
<!--            prop="classId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduClassStudent.classId"-->
<!--              :disabled="eduClassStudentState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduClassStudent.userId"-->
<!--              :disabled="eduClassStudentState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName"
                           labelValue="id" title="选择用户" :value="eduClassStudent.userId" :limit='1' size='small' placeholder='请选择用户' :disabled="eduClassStudentState == 'check'"
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="过期时间"
            prop="expireTime"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClassStudent.expireTime"
              :disabled="eduClassStudentState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="学习进度"
            prop="studyProgress"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClassStudent.studyProgress"
              :disabled="eduClassStudentState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="学习时长（秒数）"
            prop="studyTime"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClassStudent.studyTime"
              :disabled="eduClassStudentState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最后学习时间"
            prop="lastStudyTime"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClassStudent.lastStudyTime"
              :disabled="eduClassStudentState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduClassStudentState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduClassStudentList();
                    this.getEduClassStudentList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduClassStudentList();
                    this.getEduClassStudentList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     classId: '', //班级
                     userId: '', //用户
                     expireTime: '', //过期时间
                     studyProgress: '', //学习进度
                     studyTime: '', //学习时长（秒数）
                     lastStudyTime: '', //最后学习时间
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduClassStudentState: 'add',
                eduClassStudentStates: {
                    add: '添加学员',
                    check: '查看学员',
                    edit: '修改学员'
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                multipleSelection: [],
                eduClassStudentList: [],
                eduClassStudent: {
                    id: '', //
                    classId: '', //班级
                    userId: '', //用户
                    expireTime: '', //过期时间
                    studyProgress: '', //学习进度
                    studyTime: '', //学习时长（秒数）
                    lastStudyTime: '', //最后学习时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    classId: [{ required: true, message: '班级不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    expireTime: [{ required: true, message: '过期时间不能为空', trigger: 'blur' }],
                    studyProgress: [{ required: true, message: '学习进度不能为空', trigger: 'blur' }],
                    studyTime: [{ required: true, message: '学习时长（秒数）不能为空', trigger: 'blur' }],
                    lastStudyTime: [{ required: true, message: '最后学习时间不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(id){
                this.queryForm.classId = id;
                this.eduClassStudent.classId = id;
                this.getEduClassStudentList();
            },
            getValueUser(value){
                this.eduClassStudent.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            resetEduClassStudentList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduClassStudentList = [];
            },
            resetDialog() {
                this.eduClassStudentState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      classId: this.queryForm.classId, //班级
                      userId: '', //用户
                      expireTime: '', //过期时间
                      studyProgress: '', //学习进度
                      studyTime: '', //学习时长（秒数）
                      lastStudyTime: '', //最后学习时间
                };
                this.getEduClassStudentList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduClassStudent = {
                      id: '', //
                      classId: this.eduClassStudent.classId, //班级
                      userId: '', //用户
                      expireTime: '', //过期时间
                      studyProgress: '', //学习进度
                      studyTime: '', //学习时长（秒数）
                      lastStudyTime: '', //最后学习时间
                };
            },
            submitForm() {
                if (this.eduClassStudentState == 'add') {
                    this.$refs.eduClassStudentForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/classstudent/add`,{ ...this.eduClassStudent }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduClassStudentList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduClassStudentState == 'edit') {
                    this.$refs.eduClassStudentForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduClassStudent.user
                            post(`/edu/classstudent/edit`,{ ...this.eduClassStudent }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduClassStudentList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduClassStudent() {
                this.showDialog = true;
                this.eduClassStudentState = 'add';
            },
            checkEduClassStudent(eduClassStudentId) {
                console.log(eduClassStudentId);
                this.currentEduClassStudentId = eduClassStudentId;

                this.getEduClassStudentById();
                this.showDialog = true;
                this.eduClassStudentState = 'check';
            },
            editEduClassStudent(eduClassStudentId) {
                console.log('eduClassStudent', eduClassStudentId);
                if (eduClassStudentId) {
                    this.currentEduClassStudentId = eduClassStudentId;
                    this.getEduClassStudentById();
                } else {
                    this.eduClassStudent = { ...this.eduClassStudent, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduClassStudentState = 'edit';
            },
            deleteEduClassStudent(eduClassStudentId) {
                let ids = '';
                if (eduClassStudentId) {
                    ids = eduClassStudentId;
                } else {
                    ids = this.multipleSelection.map((eduClassStudent) => eduClassStudent.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/classstudent/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduClassStudentList();
                                this.getEduClassStudentList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduClassStudentList() {
                this.resetEduClassStudentList();
                this.getEduClassStudentList();
            },
            getEduClassStudentList(query = {}) {
                this.loading = true;
                get(`/edu/classstudent/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduClassStudentList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduClassStudentById() {
                get(`/edu/classstudent/get`,{ id: this.currentEduClassStudentId }).then((res) =>{
                    if(res.success){
                      this.eduClassStudent = { ...this.eduClassStudent, ...res.eduClassStudent };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduClassStudentList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/classstudent/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/classstudent/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/classstudent/importData`,formData);
              this.refreshEduClassStudentList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduClassStudentList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduClassStudentList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>